(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customer-testimonial"] && !Shopify.designMode) return;
  try {
    
  const reviewsSlider = new Swiper('.testimonial-slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    autoplay: false,
    navigation: {
      nextEl: '.reviews-slider .swiper-button-next',
      prevEl: '.reviews-slider .swiper-button-prev',
    },
    pagination: {
      el: '.reviews-slider .swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-articles"] && !Shopify.designMode) return;
  try {
    
  const articleSlider = new Swiper('.featured__articles-slider', {
    slidesPerView: 1.4,
    loop: true,
    spaceBetween: 20,
    allowTouchMove: true,
    navigation: {
      nextEl: '.featured__articles-slider .swiper-button-next',
      prevEl: '.featured__articles-slider .swiper-button-prev',
    },
    breakpoints: {
      769: {
        slidesPerView: 4,
        loop: false,
        allowTouchMove: false
      }
    }
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // Mobile dropdowns
  const headerItems = document.querySelectorAll('.footer__heading-mobile');

  headerItems.forEach((header) => {
    header.addEventListener('click', (event) => {
      const content = header.nextElementSibling;

      if (header.getAttribute('aria-expanded') == 'false') {
        header.setAttribute('aria-expanded', 'true');
        slideDown(content, 400);
      } else {
        header.setAttribute('aria-expanded', 'false');
        slideUp(content, 400);
      }
    });
  });

  // Credits
  const creditsButtons = document.querySelectorAll('a[href="#credits"]');
  const creditsCloseButtons = document.querySelectorAll('.site-credits__close');
  const credits = document.querySelector('.site-credits');

  creditsButtons.forEach((creditsButton) => {
    creditsButton.addEventListener('click', (event) => {
      event.preventDefault();
      credits.classList.add('is-visible');

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          credits.classList.remove('is-visible');
        }
      });
    });
  });

  creditsCloseButtons.forEach((creditsCloseButton) => {
    creditsCloseButton.addEventListener('click', (event) => {
      credits.classList.remove('is-visible');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  const initialCount = Number(document.querySelector('.hero__title-word.active').dataset.count);
  const length = Number(document.querySelector('.hero__title-words').dataset.length);

  let count = initialCount;
  setInterval(() => {
    count++;
    document.querySelector('.hero__title-word.active').classList.remove('active');
    document.querySelector(`.hero__title-word[data-count="${count}"]`).classList.add('active');

    if (count == length) {
      count = 0;
    }
  }, 3000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-use"] && !Shopify.designMode) return;
  try {
    
  const howToUseSlider = new Swiper('.how-to-use__slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    allowTouchMove: true,
    navigation: {
      nextEl: '.how-to-use .swiper-button-next',
      prevEl: '.how-to-use .swiper-button-prev',
    },
    pagination: {
      el: '.how-to-use .swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      769: {
        slidesPerView: 1.2,
        spaceBetween: 60,
        allowTouchMove: false
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["instagram"] && !Shopify.designMode) return;
  try {
    
  const instagramSlider = new Swiper('.instagram__container', {
    slidesPerView: 1.4,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    allowTouchMove: true,
    pagination: {
      el: '.instagram .swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 40,
        allowTouchMove: false
      } 
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["legal-popup"]) return;
  try {
    
  const legalPopup = document.querySelector('.legal-popup');
  const legalPopupCloseButtons = document.querySelectorAll('.legal-popup__close');

  if (getCookie('legalCookie')) {
    legalPopup.classList.remove('is-visible');
  } else {
    legalPopup.classList.add('is-visible');
  }

  legalPopupCloseButtons.forEach(legalPopupClose => {
    legalPopupClose.addEventListener('click', event => {
      const day = legalPopup.dataset.day;
  
      legalPopup.classList.remove('is-visible');
      setCookie('legalCookie', true, day);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-slider"] && !Shopify.designMode) return;
  try {
     
  const logoSlider = new Swiper('.logo-slider__slider', {
    slidesPerGroup: 1,
    slidesPerView: 1, 
    allowTouchMove: true,
    autoplay: {
      delay: 4000 
    },
    loop: true,
    breakpoints: {
      768: {
        slidesPerGroup: 4,
        slidesPerView: 4,
        allowTouchMove: false
      } 
    },
    pagination: {
      el: '.logo-slider .swiper-pagination' ,
      clickable: true 
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  // Scroll To Element
  const scrollElements = document.querySelectorAll('a[href^="#"]');
  scrollElements.forEach(el => {
    el.addEventListener('click', event => {
      event.preventDefault();
      const element = document.getElementById(el.getAttribute('href').replace('#', ''));
      const header = document.querySelector('.header');
      console.log( header.offsetHeight)
      window.scrollTo({ top: element.getBoundingClientRect().top + window.scrollY - header.offsetHeight, behavior: 'smooth' });
    });
  }); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bar"] && !Shopify.designMode) return;
  try {
    
  // Show bar after scroll
  const productSectionHeight = document.querySelector('.product').offsetHeight - 400;
  const headroom = new Headroom(document.querySelector('.product-bar-section'), { offset: productSectionHeight });
  headroom.init();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-features"] && !Shopify.designMode) return;
  try {
    
  const features = document.querySelectorAll('.product-features__list-item');
  const dots = document.querySelectorAll('.product-features__feature-dot');

  dots.forEach(dot => {
    dot.addEventListener('click', event => {
      const idx = dot.parentElement.dataset.idx;
      setActiveStates(idx);
    });
  });

  features.forEach(feature => {
    feature.addEventListener('click', event => {
      const idx = feature.dataset.idx;
      setActiveStates(idx);
    });
  });

  function setActiveStates(idx) {
    document.querySelector('.product-features__feature.active').classList.remove('active');
    document.querySelector(`.product-features__feature[data-idx="${idx}"]`).classList.add('active');

    document.querySelector('.product-features__list-item.active').classList.remove('active');
    document.querySelector(`.product-features__list-item[data-idx="${idx}"]`).classList.add('active');
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews-text"] && !Shopify.designMode) return;
  try {
    
  const reviewsSlider = new Swiper('.product-reviews-text__reviews', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    centeredSlides: true,
    allowTouchMove: true,
    autoplay: {
      delay: 4000,
    },
    pagination: {
      el: '.product-reviews-text .swiper-pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      769: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 40,
        allowTouchMove: false,
        autoplay: false
      } 
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-slider"] && !Shopify.designMode) return;
  try {
    
  const reviewsSlider = new Swiper('.reviews-slider__slider', {
    slidesPerView: 1,
    loop: true,
    spaceBetween: 20,
    autoplay: {
      delay: 4000,
    },
    navigation: {
      nextEl: '.reviews-slider .swiper-button-next',
      prevEl: '.reviews-slider .swiper-button-prev',
    },
    pagination: {
      el: '.reviews-slider .swiper-pagination',
      type: 'bullets',
      clickable: true
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-text-banner"] && !Shopify.designMode) return;
  try {
    
  const initialCount = Number(document.querySelector('.rotating-text-banner__title-word.active').dataset.count);
  const length = Number(document.querySelector('.rotating-text-banner__title-words').dataset.length);

  let count = initialCount;
  setInterval(() => {
    count++;
    document.querySelector('.rotating-text-banner__title-word.active').classList.remove('active');
    document.querySelector(`.rotating-text-banner__title-word[data-count="${count}"]`).classList.add('active');

    document.querySelector('.rotating-text-banner__image.active').classList.remove('active');
    document.querySelector(`.rotating-text-banner__image[data-count="${count}"]`).classList.add('active');

    if (count == length) {
      count = 0;
    }
  }, 3000);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["single-product"] && !Shopify.designMode) return;
  try {
    
  var productSliders = [];
  [...document.querySelectorAll('.single-product__image-group')].forEach((el, i) => {
    productSliders[i] = new Swiper(`.single-product__image-group[data-id="${el.dataset.id}"]`, {
      slidesPerView: 'auto',
      loop: true,
      spaceBetween: 0,
      watchOverflow:  true,
      allowTouchMove: true,
      pagination: {
        el: `.single-product__pagination[data-id="${el.dataset.id}"]`,
        clickable: true
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial-slider"] && !Shopify.designMode) return;
  try {
    
  const reviewsSlider = new Swiper('.testimonial-slider__slider', {
    slidesPerView: 1.001,
    loop: true,
    spaceBetween: 30,
    autoplay: {
      delay: 4000,
    },
    pagination: {
      el: '.testimonial-slider__pagination',
      type: 'bullets',
      clickable: true
    },
    breakpoints: {
      768: {
        spaceBetween: 60,
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  const testimonialsSlider = new Swiper('.testimonials__slider--active', {
    loop: true,
    spaceBetween: 40,
    effect: 'fade',
    speed: 800,
    autoplay: {
      delay: 4000,
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["value-prop-bar"] && !Shopify.designMode) return;
  try {
    
  // const bar = document.querySelector('.value-prop-bar');
  // const container = document.querySelector('.value-prop-bar__container');

  // handleMarquee(container.offsetWidth);
  // window.addEventListener('resize', (event) => {
  //   handleMarquee(container.offsetWidth);
  // });

  // function handleMarquee(width) {
  //   if (width + 5 > window.innerWidth) {
  //     if (!bar.classList.contains('marquee')) bar.classList.add('marquee');
  //   } else {
  //     if (bar.classList.contains('marquee')) bar.classList.remove('marquee');
  //   }
  // }

  } catch(e) { console.error(e); }
})();
})();
